import Illustration from "@portal/components/atoms/illustrations";

export const GetIconForRiskPage = (index: number) => {
  const size = "xxlarge";
  if (index === 0) return <Illustration name={"manWithChoicesYellowIcon"} size={size} />;
  if (index === 1) return <Illustration name={"womanWithMobileYellowIcon"} size={size} />;
  if (index === 2) return <Illustration name={"womanWithGoalsYellowIcon"} size={size} />;
  if (index === 3) return <Illustration name={"manWithMobileBlueIcon"} size={size} />;
};
